import { apiEmployeeEmploymentHistory } from "@/api/employees/employee-employment-history.api.ts";
import { ApiErrorException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/react-query";

export const employeeEmploymentHistoryKeys = createQueryKeys("employeeEmploymentHistory", {
  all: (employeeId: number) => ({
    queryKey: [employeeId],
    queryFn: async () => {
      const result = await apiEmployeeEmploymentHistory.getAll(employeeId);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
});

export const useEmployeeEmploymentHistory = (employeeId: number, enabled: boolean = true) => {
  return useQuery({
    ...employeeEmploymentHistoryKeys.all(employeeId),
    enabled: enabled,
  });
};
